/* ============================================================
   Shipping ETA widget — v8

   NEW IN v8:
   Special case: if today is Thursday and the order is placed
   AFTER cutoff, delivery date is forced to Saturday instead of
   the normal next-business-day chain (which would land on Monday
   because Fri->Sat/Sun get skipped). All other days keep the
   original nextBusinessDay logic untouched.
   ============================================================ */
(function () {
  console.log('[shipping-eta] v8 script file loaded');

  /* ---- Debug/testing override ----
     Add ?eta_test=YYYY-MM-DDTHH:mm:ss to simulate a Copenhagen
     wall-clock date & time. Remove after testing. */
  var etaTestParam = new URLSearchParams(window.location.search).get('eta_test');
  var etaOverrideBase = null;
  var etaOverrideAnchor = 0;
  if (etaTestParam) {
    var m = etaTestParam.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/);
    if (m) {
      etaOverrideBase = new Date(
        Number(m[1]), Number(m[2]) - 1, Number(m[3]),
        Number(m[4]), Number(m[5]), Number(m[6])
      );
      etaOverrideAnchor = Date.now();
      console.log('[shipping-eta] TEST MODE active — simulated Copenhagen time:', etaOverrideBase.toString());
    } else {
      console.warn('[shipping-eta] eta_test format invalid — use YYYY-MM-DDTHH:mm:ss with no offset:', etaTestParam);
    }
  }

  var etaDebugLogged = false;

  function getZonedNow(tz, real) {
    var dtf = new Intl.DateTimeFormat('en-US', {
      timeZone: tz,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hour12: false
    });
    var parts = {};
    dtf.formatToParts(real).forEach(function (p) {
      if (p.type !== 'literal') parts[p.type] = parseInt(p.value, 10);
    });
    if (parts.hour === 24) parts.hour = 0; // midnight quirk in some engines

    var zoned = new Date(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);

    if (!etaDebugLogged) {
      etaDebugLogged = true;
      console.log('[shipping-eta] DEBUG — device local:', real.toString());
      console.log('[shipping-eta] DEBUG — device tz:', Intl.DateTimeFormat().resolvedOptions().timeZone);
      console.log('[shipping-eta] DEBUG — target tz:', tz);
      console.log('[shipping-eta] DEBUG — Copenhagen parts:', parts);
      console.log('[shipping-eta] DEBUG — zoned Date:', zoned.toString(), '| getDay():', zoned.getDay());
    }
    return zoned;
  }

  function etaNow(tz) {
    if (etaOverrideBase) {
      var elapsed = Date.now() - etaOverrideAnchor;
      return new Date(etaOverrideBase.getTime() + elapsed);
    }
    return getZonedNow(tz, new Date());
  }

  /* ---- safe HH:MM parsing (used for both window-start and cutoff) ---- */
  function parseClockTime(raw, fallbackH, fallbackM, label) {
    var parts = (raw || '').split(':');
    var h = parseInt(parts[0], 10);
    var mnt = parseInt(parts[1], 10);
    var invalid = isNaN(h) || h < 0 || h > 23 || isNaN(mnt) || mnt < 0 || mnt > 59;
    if (invalid) {
      console.warn('[shipping-eta] Invalid ' + label + ' "' + raw + '" — falling back to ' + fallbackH + ':' + fallbackM + '.');
      return { h: fallbackH, m: fallbackM };
    }
    return { h: h, m: mnt };
  }

  function isBusinessDay(date, skipSat, skipSun) {
    var day = date.getDay();
    if (skipSun && day === 0) return false;
    if (skipSat && day === 6) return false;
    return true;
  }

  function nextBusinessDay(date, skipSat, skipSun) {
    var d = new Date(date);
    d.setDate(d.getDate() + 1);
    while (!isBusinessDay(d, skipSat, skipSun)) d.setDate(d.getDate() + 1);
    return d;
  }

  function formatDeliveryLabel(el, now, deliveryDate) {
    var oneDay = 86400000;
    var nowMid = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var delMid = new Date(deliveryDate.getFullYear(), deliveryDate.getMonth(), deliveryDate.getDate());
    var diffDays = Math.round((delMid - nowMid) / oneDay);

    if (diffDays === 0) return el.dataset.todayLabel;
    if (diffDays === 1) return el.dataset.tomorrowLabel;

    var weekdays = ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag'];
    return el.dataset.dateLabel.replace('{weekday}', weekdays[deliveryDate.getDay()]);
  }

  function pad2(n) { return n < 10 ? '0' + n : '' + n; }

  function renderMessage(el, now, cutoffH, cutoffM, cutoffMoment, showTicking, isPreWindowSameDay, deliveryDate) {
    var msgEl = el.querySelector('.shipping-eta__message');
    
    if (!msgEl) return;

    var deliveryLabel = formatDeliveryLabel(el, now, deliveryDate);
    var afterText = el.dataset.textAfter.replace('{delivery_day}', deliveryLabel);

     if (showTicking) {
  var diff = cutoffMoment - now;
  var h = pad2(Math.floor(diff / 3600000));
  var m = pad2(Math.floor((diff % 3600000) / 60000));
  var s = pad2(Math.floor((diff % 60000) / 1000));
  msgEl.innerHTML =
    el.dataset.textBefore +
    ' <span class="shipping-eta-countdown">' +
    '<span class="num">' + h + '</span> timer ' +
    '<span class="num">' + m + '</span> min ' +
    '<span class="num">' + s + '</span> sek' +
    '</span> - ' +
    afterText;
} else if (isPreWindowSameDay) {
      // Before the countdown window (e.g. before 10:00) but still same-day eligible:
      // show a static message quoting the cutoff clock-time instead of a huge tick count.
      msgEl.textContent = el.dataset.textBefore + ' kl. ' + pad2(cutoffH) + ':' + pad2(cutoffM) + ' - ' + afterText;
    } else {
  msgEl.textContent = el.dataset.withoutCutoffText + ' – ' + afterText;
}
  }

  function setupWidget(el) {
    if (el.getAttribute('data-eta-bound') === 'true') return;
    el.setAttribute('data-eta-bound', 'true');

    var cutoff = parseClockTime(el.dataset.cutoff, 14, 0, 'cutoff time');
    var windowStart = parseClockTime(el.dataset.windowStart, 10, 0, 'countdown start time');
    var skipSat = el.dataset.skipSaturday === 'true';
    var skipSun = el.dataset.skipSunday === 'true';
    var tz = el.dataset.timezone;

    function tick() {
      if (!document.body.contains(el)) {
        clearInterval(el._etaInterval);
        return;
      }

      var now = etaNow(tz);

      var cutoffMoment = new Date(now);
      cutoffMoment.setHours(cutoff.h, cutoff.m, 0, 0);

      var windowStartMoment = new Date(now);
      windowStartMoment.setHours(windowStart.h, windowStart.m, 0, 0);

      var todayIsBusiness = isBusinessDay(now, skipSat, skipSun);
      var beforeCutoff = todayIsBusiness && now < cutoffMoment;

      // Ship/delivery date math is unaffected by the countdown window — it
      // only controls whether we show a ticking countdown or a static line.
      var shipDate = beforeCutoff ? now : nextBusinessDay(now, skipSat, skipSun);
      var deliveryDate = nextBusinessDay(shipDate, skipSat, skipSun);

      // ---- Thursday special case ----
      // If today is Thursday (getDay() === 4) and cutoff has already
      // passed, deliver on Saturday instead of the normal Monday
      // (Fri ship -> skip Sat/Sun -> Mon). All other weekdays are
      // untouched.
      if (!beforeCutoff && now.getDay() === 4) {
        var saturdayDate = new Date(shipDate); // shipDate = Friday here
        saturdayDate.setDate(saturdayDate.getDate() + 1); // Friday -> Saturday
        deliveryDate = saturdayDate;
      }
      // Friday before cutoff
if (beforeCutoff && now.getDay() === 5) {
  deliveryDate = new Date(now);
  deliveryDate.setDate(deliveryDate.getDate() + 1); // Saturday
}

      var showTicking = beforeCutoff && now >= windowStartMoment;
      var isPreWindowSameDay = beforeCutoff && now < windowStartMoment;

      renderMessage(el, now, cutoff.h, cutoff.m, cutoffMoment, showTicking, isPreWindowSameDay, deliveryDate);
    }

    tick();
    el._etaInterval = setInterval(tick, 1000);
  }

  function initShippingEta() {
    var found = document.querySelectorAll('.shipping-eta:not([data-eta-bound])');
    if (found.length) console.log('[shipping-eta] binding', found.length, 'new element(s)');
    found.forEach(setupWidget);
  }

  window.addEventListener('DOMContentLoaded', initShippingEta);
  document.addEventListener('shopify:section:load', initShippingEta);
  ['cart:updated', 'cart:refresh', 'cart:build', 'ajaxCart:updated', 'cart:rendered'].forEach(function (evt) {
    document.addEventListener(evt, initShippingEta);
  });

  var etaObserver = new MutationObserver(function () {
    initShippingEta();
  });
  etaObserver.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    initShippingEta();
  }
})();